<script setup lang="ts">
import { provideProjectContext } from '@/modules/Project/useProjectContext'
import { useProjectSync } from '@/modules/Project/useProjectSync'
import { useWorkspaceContext } from '@/modules/Workspaces/useWorkspaceContext'
import CircularProgress from '@/uiKit/CircularProgress.vue'
import { computed, toRef } from 'vue'

const props = defineProps<{ projectId: string }>()

const { workspaceId } = useWorkspaceContext()
/**
 * This is the earliest in the case component tree
 * where we guarantee there is a single project record being worked with,
 * so it's the appropriate place to provide the project context
 */
provideProjectContext(toRef(props, 'projectId'))

const { loadingState } = useProjectSync({
  projectId: computed(() => props.projectId),
  workspaceId: computed(() => workspaceId.value),
})
</script>

<template>
  <div class="size-full">
    <template v-if="loadingState === 'loaded'">
      <slot />
    </template>
    <template v-else-if="loadingState === 'errored'">
      <div class="p-8 text-center text-text-critical">Could not load agent</div>
    </template>
    <template v-else>
      <div class="flex items-center justify-center p-8">
        <CircularProgress
          class="animate-spin"
          size="md"
        />
      </div>
    </template>
  </div>
</template>
